import { render, staticRenderFns } from "./bulk_quote_providers.vue?vue&type=template&id=10c5afa7"
import script from "./bulk_quote_providers.vue?vue&type=script&lang=js"
export * from "./bulk_quote_providers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports